import { useState } from 'react';
import { Link } from 'react-router-dom';
import { products, categories } from '@/mocks/products';
import { ProductCard } from './ProductCard';

export function FeaturedProducts() {
  const [activeCategory, setActiveCategory] = useState('All');

  const filtered = activeCategory === 'All'
    ? products
    : products.filter(p => p.category === activeCategory);

  return (
    <section className="py-20 bg-stone-50/50" id="products">
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        <div className="flex flex-col md:flex-row md:items-end justify-between gap-6 mb-10">
          <div>
            <p className="text-amber-600 text-sm font-medium tracking-wider uppercase mb-2">Our Collection</p>
            <h2 className="text-4xl lg:text-5xl font-bold text-stone-900" style={{ fontFamily: "'Playfair Display', serif" }}>
              Featured Products
            </h2>
          </div>
          <Link
            to="/products"
            className="inline-flex items-center gap-2 text-sm font-medium text-stone-600 hover:text-amber-600 transition-colors whitespace-nowrap"
          >
            View All <i className="ri-arrow-right-line" />
          </Link>
        </div>

        {/* Category filter */}
        <div className="flex flex-wrap gap-2 mb-8">
          {categories.map(cat => (
            <button
              key={cat}
              onClick={() => setActiveCategory(cat)}
              className={`px-4 py-2 rounded-full text-sm font-medium transition-all cursor-pointer whitespace-nowrap ${
                activeCategory === cat
                  ? 'bg-amber-500 text-white'
                  : 'bg-white text-stone-600 hover:bg-amber-50 hover:text-amber-600 border border-stone-200'
              }`}
            >
              {cat}
            </button>
          ))}
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 gap-4 lg:gap-5" data-product-shop>
          {filtered.map(product => (
            <ProductCard key={product.id} product={product} />
          ))}
        </div>
      </div>
    </section>
  );
}
